import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "./ProjectDetailsCard.css";


const ProjectDetailsCard = ({image , headding ,containar} ) => {
    return (
        
        <div className="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="100">
        <div className="property">
          <div className="property-img">
            <img src={image} className="img-fluid" alt="" />
          </div>
          <div className="property-info">
            <h4>{headding}</h4>
            <p>{containar}</p>
          </div>
        </div>
      </div>

    )
}

export default ProjectDetailsCard
